export default __webpack_public_path__ + "static/media/278899968_770416267257224_4191281877366040379_n.f964bef6.jpg";